var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowItemNutriGrade(_vm.item))?_c('v-img',{staticClass:"food-nutri-grade-img",attrs:{"src":_vm.itemNutriGradeImageUrl(_vm.item),"height":"23","width":"43"}},[_c('div',{staticClass:"food-nutri-grade-sugre-percent"},[_vm._v(_vm._s(_vm.item.sugar_percent)+"%")])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58a7bee2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemNutriGradeTag.vue
// module id = MbdT
// module chunks = 0